import { defineMessages, type MessageDescriptor } from 'react-intl';

export const messages = defineMessages({
	description: {
		id: 'twg-microsite.errorView.description',
		defaultMessage:
			"Looks like something's gone wrong. We're currently untangling things to get your context back on track.\n\nRefresh the page to give it another go.",
		description: 'Supporting copy shown below the Whoops graphic in the home page error fallback.',
	},
} as const) satisfies Record<string, MessageDescriptor>;
